import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {MobileWebViewService} from "@mpt-fo/common/core/services/mobile-web-view.service";
import {NzModalRef} from "ng-zorro-antd/modal";

@Component({
	selector: 'app-password-recovery-message',
	templateUrl: './password-recovery-message.component.html',
	styleUrls: ['./password-recovery-message.component.scss']
})
export class PasswordRecoveryMessageComponent implements OnInit {

	constructor(private router: Router, private modal: NzModalRef) {
	}

	ngOnInit(): void {
	}

	closeModal() {
		this.modal.destroy();
		this.router.navigateByUrl(`${MobileWebViewService.BASE_URL}`)
	}
}
